import { render, staticRenderFns } from "./BrowseKids.vue?vue&type=template&id=4a4502b4&"
import script from "./BrowseKids.vue?vue&type=script&lang=js&"
export * from "./BrowseKids.vue?vue&type=script&lang=js&"
import style0 from "./BrowseKids.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports